import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Index from './views/index.vue'
import { getUserInfo,getFooter,getOwnerActivity } from '@/service'

const Main = () => import(/* webpackChunkName: 'pc' */ './views/main')
const User = () => import(/* webpackChunkName: 'pc' */ './views/User/userIndex')

const SetUserInfo = () => import(/* webpackChunkName: 'pc' */ './views/UserInfo/setUserInfo')
const SetUserInfoSuccee = () => import(/* webpackChunkName: 'pc' */ './views/UserInfo/setUserInfoSuccee')

const Apply = () => import(/* webpackChunkName: 'pc' */ './views/Apply/apply')
const ApplyForOther = () => import(/* webpackChunkName: 'pc' */ './views/Apply/applyForOther')
const ApplySuccee = () => import(/* webpackChunkName: 'pc' */ './views/Apply/applySuccee')

const AddPaperInfo = () => import(/* webpackChunkName: 'pc' */ './views/Paper/addPaperInfo')
const PaperInfo = () => import(/* webpackChunkName: 'pc' */ './views/Paper/paperInfo')

const Forum = () => import(/* webpackChunkName: 'pc' */ './views/forum')
const ForumHistory = () => import(/* webpackChunkName: 'pc' */ './views/Forum/forumHistory')
const ForumTogether = () => import(/* webpackChunkName: 'pc' */ './views/Forum/forumTogether')
const ForumDetail = () => import(/* webpackChunkName: 'pc' */ './views/Forum/forumDetail')
const ForumAll = () => import(/* webpackChunkName: 'pc' */ './views/Forum/forumAll')
const StudyClass = () => import(/* webpackChunkName: 'pc' */ './views/Class/studyClass')
const StudyClassDetail = () => import(/* webpackChunkName: 'pc' */ './views/Class/studyClassDetail')
const Team = () => import(/* webpackChunkName: 'pc' */ './views/Team/team')
const TeamDetail = () => import(/* webpackChunkName: 'pc' */ './views/Team/teamDetail')
const Activity = () => import(/* webpackChunkName: 'pc' */ './views/Activity/activity')
const ActivityDetail = () => import(/* webpackChunkName: 'pc' */ './views/Activity/activityDetail')
const Partner = () => import(/* webpackChunkName: 'pc' */ './views/Partner/partner')
const ArticleDetail = () => import(/* webpackChunkName: 'pc' */ './views/Article/articleDetail')
const ReportDetail = () => import(/* webpackChunkName: 'pc' */ './views/Report/reportDetail')

const No = () => import(/* webpackChunkName: 'pc' */ './views/notfound')

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// let routes = ['/main', '/user', '/setUserInfo','/setUserInfoSuccee','/apply','/applyForOther','/applySuccee']
const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children:[
        {path: 'main', name: 'Main', component: Main },
        {path: 'user', name: 'User', component: User },

        {path: 'setUserInfo', name: 'SetUserInfo', component: SetUserInfo },
        {path: 'setUserInfoSuccee', name: 'SetUserInfoSuccee', component: SetUserInfoSuccee },

        {path: 'apply', name: 'Apply', component: Apply },
        {path: 'applyForOther', name: 'ApplyForOther', component: ApplyForOther },
        {path: 'applySuccee', name: 'ApplySuccee', component: ApplySuccee },

        {path: 'addPaperInfo', name: 'AddPaperInfo', component: AddPaperInfo },
        {path: 'paperInfo', name: 'PaperInfo', component: PaperInfo }
      ]
    },
    {path: '/forum', name: 'Forum', component: Forum},
    {path: '/forumHistory', name: 'ForumHistory', component: ForumHistory},
    {path: '/forumDetail/:id', name: 'ForumDetail', component: ForumDetail},
    {path: '/forumTogether/:id', name: 'ForumTogether', component: ForumTogether},
    {path: '/forumAll', name: 'ForumAll', component: ForumAll},
    {path: '/studyClass', name: 'StudyClass', component: StudyClass},
    {path: '/studyClassDetail/:id', name: 'StudyClassDetail', component: StudyClassDetail},
    {path: '/team', name: 'Team', component: Team},
    {path: '/teamDetail/:id', name: 'TeamDetail', component: TeamDetail},
    {path: '/activity', name: 'Activity', component: Activity},
    {path: '/activityDetail/:id', name: 'ActivityDetail', component: ActivityDetail},
    {path: '/partner', name: 'Partner', component: Partner},
    {path: '/articleDetail/:id', name: 'ArticleDetail', component: ArticleDetail},
    {path: '/reportDetail/:id', name: 'ReportDetail', component: ReportDetail},
    {path: '*', name: 'No', component: No }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
router.beforeEach(async (to, from, next) => {
  if (!store.state.is_pc && !store.state.first_load) { // 如果不是PC
    let current_href = window.location.href
    if (current_href.indexOf('mindex') == -1) {
      // console.log('router redirct')
      // return
      window.location.href = window.location.protocol + '//' + window.location.host + '/mindex'+ to.fullPath
    }
  } else {
    if (!store.state.first_load) { // 第一次进来
      if (!store.state.user_key) {
        if (localStorage.user_key && (localStorage.timestamp_right - localStorage.timestamp_left) < 1296000) {
          store.commit('updateUserKey', localStorage.user_key)
          store.commit('updateUserMobile', localStorage.user_mobile)
          let user_res = await getUserInfo({user_key: localStorage.user_key}, (error) => {
            console.log('请求错误！')
          })
          if (user_res.status == 'success') {
            localStorage.user = user_res.info?JSON.stringify(user_res.info):JSON.stringify({})
            store.commit('updateUser', user_res.info?user_res.info:{})
          }
        } else {
          window.localStorage.removeItem('timestamp_left')
          window.localStorage.removeItem('timestamp_right')
          window.localStorage.removeItem('user_key')
          window.localStorage.removeItem('user_mobile')
          window.localStorage.removeItem('user')
        }

        let apply_res = await getOwnerActivity({
          user_key: store.state.user_key
        },(error) => { console.log('请求错误！') })
        if (apply_res.status == 'success') {
          store.commit('updateApplyActivity', apply_res.activity_id)
        } else {
          console.log(apply_res)
        }
      }
      store.commit('updateFirst', true)
    }
    //请求footer合作伙伴
    let f_res = await getFooter({}, (error) => {
      console.log('暂无底部数据！')
    })
    if (f_res.status = 'success') {
      store.commit('updateFooterPartner', f_res.partner)
      store.commit('updateFooterContact', f_res.contact)
    } else {
      console.log(res.message)
    }
    if(to.path == '/') {
      next({name:'Main'})
    } else {
      next()
    }
  }
})

export default router
